import deDEJson from 'resources/i18n/de-DE.json?url';
import enJson from 'resources/i18n/en.json?url';
import esLAJson from 'resources/i18n/es-LA.json?url';
import frFRJson from 'resources/i18n/fr-FR.json?url';
import itITJson from 'resources/i18n/it-IT.json?url';
import jaJPJson from 'resources/i18n/ja-JP.json?url';
import koKOJson from 'resources/i18n/ko-KO.json?url';
import nlNLJson from 'resources/i18n/nl-NL.json?url';
import ptBRJson from 'resources/i18n/pt-BR.json?url';
import zhCNJson from 'resources/i18n/zh-CN.json?url';
import { I18N_NAMESPACE as QOMPONENTS_I18N_NAMESPACE } from '@seeqdev/qomponents';
import qomponentsDeDEJson from '@seeqdev/qomponents/i18n/de-DE.json?url';
import qomponentsEnJson from '@seeqdev/qomponents/i18n/en.json?url';
import qomponentsEsLAJson from '@seeqdev/qomponents/i18n/es-LA.json?url';
import qomponentsFrFRJson from '@seeqdev/qomponents/i18n/fr-FR.json?url';
import qomponentsItITJson from '@seeqdev/qomponents/i18n/it-IT.json?url';
import qomponentsJaJPJson from '@seeqdev/qomponents/i18n/ja-JP.json?url';
import qomponentsKoKOJson from '@seeqdev/qomponents/i18n/ko-KO.json?url';
import qomponentsNlNLJson from '@seeqdev/qomponents/i18n/nl-NL.json?url';
import qomponentsPtBRJson from '@seeqdev/qomponents/i18n/pt-BR.json?url';
import qomponentsZhCNJson from '@seeqdev/qomponents/i18n/zh-CN.json?url';
import type { ValueOf } from '@/utilities.types';

/**
 *  Supported languages (string translations) within the app.
 *  Changing the selected language will not affect date formatting.
 *  For that, see `MOMENT_LOCALE_DATA`.
 **/
export const LOCALES = {
  EN: 'en',
  ES: 'es-LA',
  DE: 'de-DE',
  FR: 'fr-FR',
  IT: 'it-IT',
  JA: 'ja-JP',
  KO: 'ko-KO',
  NL: 'nl-NL',
  PT: 'pt-BR',
  ZH: 'zh-CN',
} as const;
export type LocaleKey = ValueOf<typeof LOCALES>;

export type AgGridLocale = {
  [key in LocaleKey]: Record<string, string>;
};

/**
 * For the language selector in the user profile modal, we do not want to translate the text since we want each
 * language label to be in its respective language.
 */
type LocaleData = { key: LocaleKey; text: string; translationPath: string };
export const LOCALE_DATA: LocaleData[] = [
  { key: LOCALES.EN, text: 'English', translationPath: enJson },
  { key: LOCALES.ES, text: 'Español', translationPath: esLAJson },
  { key: LOCALES.FR, text: 'Français', translationPath: frFRJson },
  { key: LOCALES.DE, text: 'Deutsch', translationPath: deDEJson },
  { key: LOCALES.IT, text: 'Italiano', translationPath: itITJson },
  { key: LOCALES.JA, text: '日本語', translationPath: jaJPJson },
  { key: LOCALES.KO, text: '한국어', translationPath: koKOJson },
  { key: LOCALES.NL, text: 'Nederlands', translationPath: nlNLJson },
  { key: LOCALES.PT, text: 'Português', translationPath: ptBRJson },
  { key: LOCALES.ZH, text: '简体中文(中)', translationPath: zhCNJson },
];

type NamespacedLocaleData = { key: LocaleKey; translationPath: string };

export const NAMESPACED_LOCALE_DATA: Record<string, NamespacedLocaleData[]> = {
  [QOMPONENTS_I18N_NAMESPACE]: [
    { key: LOCALES.EN, translationPath: qomponentsEnJson },
    { key: LOCALES.DE, translationPath: qomponentsDeDEJson },
    { key: LOCALES.ES, translationPath: qomponentsEsLAJson },
    { key: LOCALES.FR, translationPath: qomponentsFrFRJson },
    { key: LOCALES.IT, translationPath: qomponentsItITJson },
    { key: LOCALES.JA, translationPath: qomponentsJaJPJson },
    { key: LOCALES.KO, translationPath: qomponentsKoKOJson },
    { key: LOCALES.NL, translationPath: qomponentsNlNLJson },
    { key: LOCALES.PT, translationPath: qomponentsPtBRJson },
    { key: LOCALES.ZH, translationPath: qomponentsZhCNJson },
  ],
};
